import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Home Icon (House-Entrance) from Figma
 * @link [Figma](https://www.figma.com/design/ARyRA98QKWA7iJ6jEuCY1l/Clarity?node-id=1008-101910)
 * */
const HomeIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.8291 0.394531C5.95576 0.328383 6.11157 0.338535 6.22852 0.426758L11.3223 4.27051C11.3323 4.27806 11.3424 4.28641 11.3516 4.29492C11.528 4.45822 11.6338 4.68379 11.6475 4.92383C11.6479 4.93089 11.6484 4.93824 11.6484 4.94531V10.8184C11.6474 11.0387 11.5592 11.2495 11.4033 11.4053C11.2473 11.5611 11.0359 11.6487 10.8154 11.6494H7.75781C7.55071 11.6494 7.38281 11.4815 7.38281 11.2744V8.81348C7.3827 8.44689 7.23677 8.09516 6.97754 7.83594C6.71823 7.57674 6.36664 7.43066 6 7.43066C5.63336 7.43066 5.28177 7.57674 5.02246 7.83594C4.76323 8.09516 4.6173 8.44689 4.61719 8.81348V11.2734C4.61719 11.4805 4.44929 11.6484 4.24219 11.6484H1.18359C0.963157 11.6477 0.75158 11.5602 0.595703 11.4043C0.439826 11.2484 0.352305 11.0368 0.351562 10.8164V4.94531C0.351562 4.93847 0.352164 4.93164 0.352539 4.9248C0.365841 4.68424 0.472351 4.45831 0.649414 4.29492L0.677734 4.27051L5.77637 0.426758L5.8291 0.394531ZM8.13281 10.8994H10.8135C10.8358 10.8993 10.8572 10.8907 10.873 10.875C10.8886 10.8594 10.898 10.8384 10.8984 10.8164V4.96289C10.8951 4.91989 10.8754 4.8808 10.8447 4.85059L6.00195 1.19629L1.15137 4.85254C1.12248 4.88209 1.10482 4.92061 1.10156 4.96191V10.8135L1.1084 10.8457C1.11262 10.856 1.11798 10.866 1.12598 10.874C1.14182 10.8899 1.16411 10.8984 1.18652 10.8984H3.86719V8.81348C3.8673 8.24797 4.09231 7.70554 4.49219 7.30566C4.89215 6.90582 5.43444 6.68066 6 6.68066C6.56556 6.68066 7.10785 6.90582 7.50781 7.30566C7.90769 7.70554 8.1327 8.24797 8.13281 8.81348V10.8994Z" className="fill-current" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default HomeIcon;